// extracted by mini-css-extract-plugin
export default {"link":"LinkMenuItem_link__JkYNU","title":"LinkMenuItem_title__eHL8N","icon":"LinkMenuItem_icon__JqINc"};